import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Extension from "@material-ui/icons/Extension";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import LocalMovies from "@material-ui/icons/LocalMovies";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/material-kit-react/views/homePageSections/productStyle.jsx";

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Des bots pour animer vos conversations en ligne</h2>
            <h5 className={classes.description}>
              Grâce aux bots Repliculte, envoyez des répliques personnalisées à vos interlocuteurs.
            </h5>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Commande Slack"
                description="Sur Slack, la commande /repliculte [text] interroge notre base de données de vidéos et affiche la vidéo qui correspond le mieux à votre demande."
                icon={Extension}
                iconColor="warning"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Des extraits certifiés"
                description="Tous les extraits que nous recensons sont validés par notre équipe."
                icon={VerifiedUser}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Des centaines d'extraits"
                description="Profitez pleinement de la puissance de notre base de données, constituées de plus de 300 extraits, et enrichissez-la de vos meilleures citations !"
                icon={LocalMovies}
                iconColor="info"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/HomePage/Sections/ProductSection.jsx